

// import React, { useState, useEffect } from "react";
// import "./NewPatientRegistration.css";

// const SupplierMaster = ({ screenAction, triggerSave }) => {
//   const [isDisabled, setIsDisabled] = useState(true);
//   const [searchText, setSearchText] = useState("");
//   const [suppliers, setSuppliers] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [itemsMasterList, setItemsMasterList] = useState([]);
  
//   // GST State
//   const [gstStatus, setGstStatus] = useState(null);
//   const [isVerifyingGST, setIsVerifyingGST] = useState(false);

//   const initialFormState = {
//     supplierCd: "",
//     supplierName: "",
//     supplierAddress: "",
//     contactPerson: "",
//     contactPersonPhone: "",
//     contactPersonEmail: "",
//     creditDays: "",
//     tin: "",
//     pan: "",
//     tdsSection: "",
//     bankAccountNumber: "",
//     bankBranch: "",
//     ifsc: "",
//     gstRegistration: "Y",
//     gstNo: ""
//   };

//   const [formData, setFormData] = useState(initialFormState);
  
//   const [tableRows, setTableRows] = useState([
//     { id: Date.now(), itemCd: "", itemDesc: "" }
//   ]);

//   // Load Items List for the Dropdown
//   useEffect(() => {
//     const fetchItems = async () => {
//       try {
//         const res = await fetch("https://hmsapi.emedhatechnologies.com/master/api/api/itemsmasterform");
//         const data = await res.json();
//         setItemsMasterList(data);
//       } catch (err) {
//         console.error("Error fetching items:", err);
//       }
//     };
//     fetchItems();
//   }, []);

//   // --- SEARCH AND SELECT LOGIC ---
//   const searchSuppliers = async (text) => {
//     setSearchText(text);
//     if (text.length < 1) {
//       setSuppliers([]);
//       return;
//     }
//     try {
//       const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/suppliermaster`);
//       const data = await res.json();
//       const filtered = data.filter(sup => 
//         sup.supplierCd.toString().includes(text) || 
//         sup.supplierName.toLowerCase().includes(text.toLowerCase())
//       );
//       setSuppliers(filtered);
//       setShowDropdown(true);
//     } catch (err) {
//       console.error("Search error:", err);
//     }
//   };

//   const selectSupplier = async (supplier) => {
//     // Fetch complete supplier details including mapped items
//     try {
//       const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/suppliermaster/${supplier.supplierCd}`);
//       const data = await res.json(); // Assuming backend returns { ...supplier, items: [...] }
      
//       setFormData(data);
      
//       // Populate table or set empty row if no items
//       if (data.items && data.items.length > 0) {
//         const loadedRows = data.items.map(it => ({
//           id: Math.random(),
//           itemCd: it.itemCd,
//           itemDesc: it.itemDesc || itemsMasterList.find(m => m.itemCd == it.itemCd)?.itemDesc || ""
//         }));
//         setTableRows(loadedRows);
//       } else {
//         setTableRows([{ id: Date.now(), itemCd: "", itemDesc: "" }]);
//       }

//       setSearchText(`${data.supplierCd} | ${data.supplierName}`);
//       setShowDropdown(false);
//       setGstStatus(null); // Reset GST UI

//       if (screenAction === "edit") setIsDisabled(false);
//       if (screenAction === "view") setIsDisabled(true);
//     } catch (err) {
//       console.error("Error loading supplier details:", err);
//     }
//   };

//   // --- FORM ACTIONS ---
//   const clearForm = () => {
//     const fetchLatestId = async () => {
//       try {
//         const res = await fetch("https://hmsapi.emedhatechnologies.com/master/api/api/suppliermaster");
//         const allSuppliers = await res.json();
//         const lastId = Math.max(...allSuppliers.map(s => parseInt(s.supplierCd) || 0), 0);
        
//         setFormData({
//           ...initialFormState,
//           supplierCd: (lastId + 1).toString()
//         });
//       } catch (err) {
//         console.error("Error fetching last ID", err);
//       }
//     };
    
//     fetchLatestId();
//     setTableRows([{ id: Date.now(), itemCd: "", itemDesc: "" }]);
//     setSearchText("");
//     setGstStatus(null);
//     setIsDisabled(false);
//   };

//   const enableEditing = () => setIsDisabled(false);
//   const disableEditing = () => setIsDisabled(true);

//   const refreshForm = () => {
//     if (formData.supplierCd && (formData.hospital_id || formData.created_at)) {
//       selectSupplier(formData); // Reload current
//     } else {
//       clearForm();
//     }
//   };

//   const printForm = () => {
//     const newWindow = window.open("", "", "width=900,height=700");
//     const today = new Date().toLocaleDateString();

//     const htmlContent = `
//       <html>
//         <head>
//           <title>Supplier Master - ${formData.supplierName}</title>
//           <style>
//             body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; padding: 40px; color: #333; }
//             .header { display: flex; justify-content: space-between; border-bottom: 2px solid #0056b3; padding-bottom: 10px; margin-bottom: 20px; }
//             .header h1 { margin: 0; font-size: 24px; color: #0056b3; }
//             .section-header { background: #e9ecef; padding: 8px 12px; font-weight: bold; border-left: 4px solid #0056b3; margin-top: 20px; margin-bottom: 10px; }
//             .grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; }
//             .item { display: flex; border-bottom: 1px dotted #ccc; padding: 6px 0; font-size: 13px; }
//             .label { width: 160px; font-weight: 600; color: #555; }
//             .value { flex: 1; font-weight: 500; }
//             table { width: 100%; border-collapse: collapse; margin-top: 15px; }
//             th, td { border: 1px solid #ccc; padding: 8px; text-align: left; font-size: 13px; }
//             th { background: #f4f4f4; }
//           </style>
//         </head>
//         <body>
//           <div class="header">
//             <div>
//               <h1>EMEDHA CARE HOSPITAL</h1>
//               <p style="margin:2px 0; font-size:12px;">Supplier Master Report</p>
//             </div>
//             <div style="text-align: right;">
//               <p>Date: ${today}</p>
//             </div>
//           </div>

//           <div class="section-header">Supplier Details</div>
//           <div class="grid">
//             <div class="item"><span class="label">Supplier Code:</span><span class="value">${formData.supplierCd}</span></div>
//             <div class="item"><span class="label">Supplier Name:</span><span class="value">${formData.supplierName}</span></div>
//             <div class="item"><span class="label">Contact Person:</span><span class="value">${formData.contactPerson}</span></div>
//             <div class="item"><span class="label">Phone:</span><span class="value">${formData.contactPersonPhone}</span></div>
//             <div class="item"><span class="label">Email:</span><span class="value">${formData.contactPersonEmail}</span></div>
//             <div class="item"><span class="label">GST No:</span><span class="value">${formData.gstNo}</span></div>
//           </div>

//           <div class="section-header">Mapped Items</div>
//           <table>
//             <thead>
//               <tr>
//                 <th>Sl No.</th>
//                 <th>Item Code</th>
//                 <th>Item Description</th>
//               </tr>
//             </thead>
//             <tbody>
//               ${tableRows.filter(r => r.itemCd).map((row, i) => `
//                 <tr>
//                   <td>${i + 1}</td>
//                   <td>${row.itemCd}</td>
//                   <td>${row.itemDesc}</td>
//                 </tr>
//               `).join('')}
//             </tbody>
//           </table>
//         </body>
//       </html>
//     `;

//     newWindow.document.write(htmlContent);
//     newWindow.document.close();
//     setTimeout(() => {
//       newWindow.print();
//       newWindow.close();
//     }, 700);
//   };

//   useEffect(() => {
//     if (screenAction === "add") clearForm();
//     if (screenAction === "edit") enableEditing();
//     if (screenAction === "view") disableEditing();
//     if (screenAction === "refresh") refreshForm();
//     if (screenAction === "print") printForm();
//   }, [screenAction]);

//   // --- GST Verification ---
//   const verifyGST = async () => {
//     if (!formData.gstNo) return alert("Please enter a GST Number first.");
//     setIsVerifyingGST(true);
//     setGstStatus(null);

//     try {
//       const response = await fetch("https://hmsapi.emedhatechnologies.com/master/api/api/verify-gstin", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ GSTIN: formData.gstNo })
//       });
//       const data = await response.json();

//       if (response.ok && data.valid === true) { 
//         setGstStatus("verified");
//       } else {
//         setGstStatus("failed");
//       }
//     } catch (error) {
//       setGstStatus("failed");
//     } finally {
//       setIsVerifyingGST(false);
//     }
//   };

//   // --- Input Handlers ---
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//     if (name === "gstNo") setGstStatus(null);
//   };

//   const handleItemSelect = (index, selectedItemCd) => {
//     const selectedItem = itemsMasterList.find(it => it.itemCd.toString() === selectedItemCd.toString());
//     const updatedRows = [...tableRows];
//     updatedRows[index].itemCd = selectedItemCd;
//     updatedRows[index].itemDesc = selectedItem ? selectedItem.itemDesc : "";
//     setTableRows(updatedRows);
//   };

//   const addRow = () => setTableRows([...tableRows, { id: Date.now(), itemCd: "", itemDesc: "" }]);
  
//   const removeRow = (indexToRemove) => {
//     if (tableRows.length > 1) {
//       setTableRows(tableRows.filter((_, index) => index !== indexToRemove));
//     }
//   };

//   // --- Save Logic ---
//   const handleSubmit = async () => {
//     const user = JSON.parse(localStorage.getItem("user"));
//     if (!formData.supplierName) return alert("Supplier Name is required");

//     const validItems = tableRows.filter(row => row.itemCd !== "");
//     const payload = {
//       ...formData,
//       created_by: user?.id,
//       items: validItems
//     };

//     const method = formData.hospital_id ? "PUT" : "POST";
//     const url = method === "POST" 
//       ? "https://hmsapi.emedhatechnologies.com/master/api/api/suppliermaster" 
//       : `https://hmsapi.emedhatechnologies.com/master/api/api/suppliermaster/${formData.supplierCd}`;

//     try {
//       const res = await fetch(url, {
//         method,
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload)
//       });
//       if (res.ok) {
//         alert("Supplier Saved Successfully!");
//         if (method === "POST") clearForm();
//       }
//     } catch (err) {
//       alert("Error saving supplier");
//     }
//   };

//   useEffect(() => {
//     if (triggerSave > 0 && screenAction === "save") handleSubmit();
//   }, [triggerSave]);

//   return (
//     <div className="registration-container fade-in">
      
//       {/* SEARCH BAR FOR EDIT/VIEW */}
//       {(screenAction === "edit" || screenAction === "view") && (
//         <div className="patient-search">
//           <label>Search Supplier Master</label>
//           <input
//             type="text"
//             value={searchText}
//             placeholder="Search by Supplier ID or Name"
//             onChange={(e) => searchSuppliers(e.target.value)}
//           />
//           {showDropdown && suppliers.length > 0 && (
//             <div className="patient-dropdown">
//               {suppliers.map((sup) => (
//                 <div key={sup.supplierCd} className="patient-item" onClick={() => selectSupplier(sup)}>
//                   {sup.supplierCd} | {sup.supplierName}
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       )}

//       <form className="luxury-form">
        
//         {/* IDENTIFICATION ROW */}
//         <div className="form-grid" style={{ marginBottom: '20px' }}>
//            <div className="input-box read-only">
//             <label style={{ fontSize: '12px', fontWeight: 'bold' }}>Supplier ID</label>
//             <input type="text" name="supplierCd" value={formData.supplierCd} readOnly style={{ width: '150px' }} />
//           </div>
//         </div>

//         {/* DETAILS GRID */}
//         <div className="form-grid">
//           {/* Now side-by-side because they are standard input-boxes */}
//           <div className="input-box">
//             <label>Supplier Name</label>
//             <input type="text" name="supplierName" value={formData.supplierName} onChange={handleChange} disabled={isDisabled} />
//           </div>
//           <div className="input-box">
//             <label>Supplier Address</label>
//             <input type="text" name="supplierAddress" value={formData.supplierAddress} onChange={handleChange} disabled={isDisabled} />
//           </div>

//           <div className="input-box">
//             <label>Contact Person</label>
//             <input type="text" name="contactPerson" value={formData.contactPerson} onChange={handleChange} disabled={isDisabled} />
//           </div>
//           <div className="input-box">
//             <label>Contact Person Phone</label>
//             <input type="text" name="contactPersonPhone" value={formData.contactPersonPhone} onChange={handleChange} disabled={isDisabled} />
//           </div>
          
//           <div className="input-box">
//             <label>Contact Person Email</label>
//             <input type="email" name="contactPersonEmail" value={formData.contactPersonEmail} onChange={handleChange} disabled={isDisabled} />
//           </div>
//           <div className="input-box">
//             <label>Credit Days</label>
//             <input type="number" name="creditDays" value={formData.creditDays} onChange={handleChange} disabled={isDisabled} />
//           </div>
          
//           <div className="input-box">
//             <label>TIN</label>
//             <input type="text" name="tin" value={formData.tin} onChange={handleChange} disabled={isDisabled} />
//           </div>
//           <div className="input-box">
//             <label>PAN</label>
//             <input type="text" name="pan" value={formData.pan} onChange={handleChange} disabled={isDisabled} />
//           </div>

//           <div className="input-box">
//             <label>TDS Section</label>
//             <input type="text" name="tdsSection" value={formData.tdsSection} onChange={handleChange} disabled={isDisabled} />
//           </div>
//           <div className="input-box">
//             <label>Bank Account Number</label>
//             <input type="text" name="bankAccountNumber" value={formData.bankAccountNumber} onChange={handleChange} disabled={isDisabled} />
//           </div>
          
//           <div className="input-box">
//             <label>Bank Branch</label>
//             <input type="text" name="bankBranch" value={formData.bankBranch} onChange={handleChange} disabled={isDisabled} />
//           </div>
//           <div className="input-box">
//             <label>IFSC</label>
//             <input type="text" name="ifsc" value={formData.ifsc} onChange={handleChange} disabled={isDisabled} />
//           </div>
          
//           <div className="input-box">
//             <label>GST Registration</label>
//             <select name="gstRegistration" value={formData.gstRegistration} onChange={handleChange} disabled={isDisabled}>
//               <option value="Y">Y</option>
//               <option value="N">N</option>
//             </select>
//           </div>
          
//           {/* GST NUMBER WITH INLINE BUTTON BELOW IT */}
//           <div className="input-box">
//             <label>GST No</label>
//             <input type="text" name="gstNo" value={formData.gstNo} onChange={handleChange} disabled={isDisabled} />
            
//             {formData.gstRegistration === "Y" && (
//               <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '8px' }}>
//                 <button 
//                   type="button" 
//                   onClick={verifyGST} 
//                   disabled={isDisabled || !formData.gstNo || isVerifyingGST}
//                   style={{ 
//                     padding: '4px 12px', 
//                     backgroundColor: '#007bff', 
//                     color: 'white', 
//                     border: 'none', 
//                     borderRadius: '4px', 
//                     cursor: 'pointer',
//                     fontSize: '12px'
//                   }}
//                 >
//                   {isVerifyingGST ? "Verifying..." : "Verify GST"}
//                 </button>
//                 {gstStatus === "failed" && <span style={{ color: 'red', fontSize: '12px', fontWeight: 'bold' }}>GST Verification Failed</span>}
//                 {gstStatus === "verified" && <span style={{ color: 'green', fontSize: '12px', fontWeight: 'bold' }}>Verified</span>}
//               </div>
//             )}
//           </div>
//         </div>

//         {/* DYNAMIC ITEMS TABLE */}
//         <div className="dynamic-table-wrapper" style={{ marginTop: '20px', overflowX: 'auto', border: '1px solid #ccc', borderRadius: '4px' }}>
//           <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', minWidth: '600px' }}>
//             <thead style={{ backgroundColor: '#e9ecef', borderBottom: '2px solid #ccc' }}>
//               <tr>
//                 <th style={{ padding: '10px', borderRight: '1px solid #ccc', width: '60px' }}>Sl No.</th>
//                 <th style={{ padding: '10px', borderRight: '1px solid #ccc', width: '30%' }}>Item Code 1</th>
//                 <th style={{ padding: '10px' }}>Item Description</th>
//                 <th style={{ padding: '10px', width: '50px', textAlign: 'center' }}>X</th>
//               </tr>
//             </thead>
//             <tbody>
//               {tableRows.map((row, index) => (
//                 <tr key={row.id} style={{ borderBottom: '1px solid #ddd', backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
//                   <td style={{ padding: '10px', borderRight: '1px solid #ccc', textAlign: 'center' }}>{index + 1}</td>
//                   <td style={{ padding: '10px', borderRight: '1px solid #ccc' }}>
//                     <select 
//                       value={row.itemCd} 
//                       onChange={(e) => handleItemSelect(index, e.target.value)}
//                       disabled={isDisabled}
//                       style={{ width: '100%', padding: '6px', border: '1px solid #ccc', borderRadius: '4px' }}
//                     >
//                       <option value="">Select Item</option>
//                       {itemsMasterList.map(item => (
//                         <option key={item.itemCd} value={item.itemCd}>
//                           {item.itemCd} - {item.itemDesc}
//                         </option>
//                       ))}
//                     </select>
//                   </td>
//                   <td style={{ padding: '10px' }}>{row.itemDesc}</td>
//                   <td style={{ padding: '10px', textAlign: 'center' }}>
//                     {!isDisabled && tableRows.length > 1 && (
//                        <button type="button" onClick={() => removeRow(index)} style={{ color: 'red', fontWeight: 'bold', cursor: 'pointer', border: 'none', background: 'none' }}>X</button>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//           {!isDisabled && (
//             <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px', backgroundColor: '#e9ecef' }}>
//               <button 
//                 type="button" 
//                 onClick={addRow}
//                 style={{ padding: '6px 12px', cursor: 'pointer', backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px', fontWeight: 'bold' }}
//               >
//                 + Add Row
//               </button>
//             </div>
//           )}
//         </div>

//       </form>
//     </div>
//   );
// };

// export default SupplierMaster;

import React, { useState, useEffect } from "react";
import "./NewPatientRegistration.css";

const SupplierMaster = ({ screenAction, triggerSave }) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [suppliers, setSuppliers] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [itemsMasterList, setItemsMasterList] = useState([]);
  
  // GST State
  const [gstStatus, setGstStatus] = useState(null);
  const [isVerifyingGST, setIsVerifyingGST] = useState(false);

  const initialFormState = {
    supplierCd: "",
    supplierName: "",
    supplierAddress: "",
    contactPerson: "",
    contactPersonPhone: "",
    contactPersonEmail: "",
    creditDays: "",
    tin: "",
    pan: "",
    tdsSection: "",
    bankAccountNumber: "",
    bankBranch: "",
    ifsc: "",
    gstRegistration: "Y",
    gstNo: ""
  };

  const [formData, setFormData] = useState(initialFormState);
  
  const [tableRows, setTableRows] = useState([
    { id: Date.now(), itemCd: "", itemDesc: "" }
  ]);

  // Load Items List for the Dropdown
  useEffect(() => {
    const fetchItems = async () => {
      try {
        const res = await fetch("https://hmsapi.emedhatechnologies.com/master/api/api/itemsmasterform");
        const data = await res.json();
        setItemsMasterList(data);
      } catch (err) {
        console.error("Error fetching items:", err);
      }
    };
    fetchItems();
  }, []);

  // --- NEW SEARCH LOGIC USING API ---
  const searchSuppliers = async (text) => {
      const user = JSON.parse(localStorage.getItem("user"));
    setSearchText(text);
    if (text.length < 1) {
      setSuppliers([]);
      return;
    }
    try {
      // Uses the new Search API
      const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/suppliermaster/search?q=${text}&employee_id=${user.id}`);
      const data = await res.json();
      setSuppliers(data);
      setShowDropdown(true);
    } catch (err) {
      console.error("Search error:", err);
    }
  };

  const selectSupplier = async (supplier) => {
    try {
      const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/suppliermaster/${supplier.supplierCd}`);
      const data = await res.json();
      
    setFormData({
  ...data,
  _isExisting: true   // ✅ ADD THIS
});
      
      // Populate table with saved items
      if (data.items && data.items.length > 0) {
        const loadedRows = data.items.map(it => ({
          id: Math.random(),
          itemCd: it.itemCd,
          itemDesc: it.itemDesc
        }));
        setTableRows(loadedRows);
      } else {
        setTableRows([{ id: Date.now(), itemCd: "", itemDesc: "" }]);
      }

      setSearchText(`${data.supplierCd} | ${data.supplierName}`);
      setShowDropdown(false);
      setGstStatus(null); 

      if (screenAction === "edit") setIsDisabled(false);
      if (screenAction === "view") setIsDisabled(true);
    } catch (err) {
      console.error("Error loading supplier details:", err);
    }
  };

  // --- FORM ACTIONS ---
  const clearForm = () => {
    const fetchLatestId = async () => {
      try {
        const res = await fetch("https://hmsapi.emedhatechnologies.com/master/api/api/suppliermaster");
        const allSuppliers = await res.json();
        const lastId = Math.max(...allSuppliers.map(s => parseInt(s.supplierCd) || 0), 0);
        
        setFormData({
          ...initialFormState,
          supplierCd: (lastId + 1).toString()
        });
      } catch (err) {
        console.error("Error fetching last ID", err);
      }
    };
    
    fetchLatestId();
    setTableRows([{ id: Date.now(), itemCd: "", itemDesc: "" }]);
    setSearchText("");
    setGstStatus(null);
    setIsDisabled(false);
  };

  const enableEditing = () => setIsDisabled(false);
  const disableEditing = () => setIsDisabled(true);

  const refreshForm = () => {
    if (formData.supplierCd && formData.supplierName) {
      selectSupplier({ supplierCd: formData.supplierCd }); // Reload current
    } else {
      clearForm();
    }
  };

  const printForm = () => {
    const newWindow = window.open("", "", "width=900,height=700");
    const today = new Date().toLocaleDateString();

    const htmlContent = `
      <html>
        <head>
          <title>Supplier Master - ${formData.supplierName}</title>
          <style>
            body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; padding: 40px; color: #333; }
            .header { display: flex; justify-content: space-between; border-bottom: 2px solid #0056b3; padding-bottom: 10px; margin-bottom: 20px; }
            .header h1 { margin: 0; font-size: 24px; color: #0056b3; }
            .section-header { background: #e9ecef; padding: 8px 12px; font-weight: bold; border-left: 4px solid #0056b3; margin-top: 20px; margin-bottom: 10px; }
            .grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; }
            .item { display: flex; border-bottom: 1px dotted #ccc; padding: 6px 0; font-size: 13px; }
            .label { width: 160px; font-weight: 600; color: #555; }
            .value { flex: 1; font-weight: 500; }
            table { width: 100%; border-collapse: collapse; margin-top: 15px; }
            th, td { border: 1px solid #ccc; padding: 8px; text-align: left; font-size: 13px; }
            th { background: #f4f4f4; }
          </style>
        </head>
        <body>
          <div class="header">
            <div>
              <h1>EMEDHA CARE HOSPITAL</h1>
              <p style="margin:2px 0; font-size:12px;">Supplier Master Report</p>
            </div>
            <div style="text-align: right;">
              <p>Date: ${today}</p>
            </div>
          </div>

          <div class="section-header">Supplier Details</div>
          <div class="grid">
            <div class="item"><span class="label">Supplier Code:</span><span class="value">${formData.supplierCd}</span></div>
            <div class="item"><span class="label">Supplier Name:</span><span class="value">${formData.supplierName}</span></div>
            <div class="item"><span class="label">Contact Person:</span><span class="value">${formData.contactPerson}</span></div>
            <div class="item"><span class="label">Phone:</span><span class="value">${formData.contactPersonPhone}</span></div>
            <div class="item"><span class="label">Email:</span><span class="value">${formData.contactPersonEmail}</span></div>
            <div class="item"><span class="label">GST No:</span><span class="value">${formData.gstNo}</span></div>
          </div>

          <div class="section-header">Mapped Items</div>
          <table>
            <thead>
              <tr>
                <th>Sl No.</th>
                <th>Item Code</th>
                <th>Item Description</th>
              </tr>
            </thead>
            <tbody>
              ${tableRows.filter(r => r.itemCd).map((row, i) => `
                <tr>
                  <td>${i + 1}</td>
                  <td>${row.itemCd}</td>
                  <td>${row.itemDesc}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </body>
      </html>
    `;

    newWindow.document.write(htmlContent);
    newWindow.document.close();
    setTimeout(() => {
      newWindow.print();
      newWindow.close();
    }, 700);
  };




  useEffect(() => {
    if (screenAction === "add") clearForm();
    if (screenAction === "edit") enableEditing();
    if (screenAction === "view") disableEditing();
    if (screenAction === "refresh") refreshForm();
    if (screenAction === "print") printForm();
  }, [screenAction]);

  // --- GST Verification ---
  const verifyGST = async () => {
    if (!formData.gstNo) return alert("Please enter a GST Number first.");
    setIsVerifyingGST(true);
    setGstStatus(null);

    try {
      const response = await fetch("https://hmsapi.emedhatechnologies.com/master/api/api/verify-gstin", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ GSTIN: formData.gstNo })
      });
      const data = await response.json();

      if (response.ok && data.valid === true) { 
        setGstStatus("verified");
      } else {
        setGstStatus("failed");
      }
    } catch (error) {
      setGstStatus("failed");
    } finally {
      setIsVerifyingGST(false);
    }
  };

  // --- Input Handlers ---
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (name === "gstNo") setGstStatus(null);
  };

  const handleItemSelect = (index, selectedItemCd) => {
    const selectedItem = itemsMasterList.find(it => it.itemCd.toString() === selectedItemCd.toString());
    const updatedRows = [...tableRows];
    updatedRows[index].itemCd = selectedItemCd;
    updatedRows[index].itemDesc = selectedItem ? selectedItem.itemDesc : "";
    setTableRows(updatedRows);
  };

  const addRow = () => setTableRows([...tableRows, { id: Date.now(), itemCd: "", itemDesc: "" }]);
  
  const removeRow = (indexToRemove) => {
    if (tableRows.length > 1) {
      setTableRows(tableRows.filter((_, index) => index !== indexToRemove));
    }
  };

  // --- Save Logic ---
  const handleSubmit = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!formData.supplierName) return alert("Supplier Name is required");

    const validItems = tableRows.filter(row => row.itemCd !== "");
    const payload = {
      ...formData,
      created_by: user?.id,
      items: validItems
    };

    delete payload._isExisting; // ✅ IMPORTANT

    // If we loaded data into the form via search, it will have formData.supplierCd that maps to an existing record.
    // Ensure you dictate edit vs save. Usually, checking `screenAction === "edit"` or if it already exists is safer.
    // const isEditing = screenAction === "edit" && formData.supplierCd !== "";
    const method = formData._isExisting ? "PUT" : "POST";
  const url =
    method === "POST"
      ? "https://hmsapi.emedhatechnologies.com/master/api/api/suppliermaster"
      : `https://hmsapi.emedhatechnologies.com/master/api/api/suppliermaster/${formData.supplierCd}`;

    try {
      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      
      if (res.ok) {
        alert("Supplier Saved Successfully!");
        if (method === "POST") clearForm(); // Reset form for the next entry
      } else {
        const errorData = await res.json();
        alert(`Error: ${errorData.message}`);
      }
    } catch (err) {
      alert("Error saving supplier");
    }
  };

  useEffect(() => {
    if (triggerSave > 0 && screenAction === "save") handleSubmit();
  }, [triggerSave]);

  return (
    <div className="registration-container fade-in">
      
      {/* SEARCH BAR FOR EDIT/VIEW */}
      {(screenAction === "edit" || screenAction === "view") && (
        <div className="patient-search">
          <label>Search Supplier Master</label>
          <input
            type="text"
            value={searchText}
            placeholder="Search by Supplier ID or Name"
            onChange={(e) => searchSuppliers(e.target.value)}
          />
          {showDropdown && suppliers.length > 0 && (
            <div className="patient-dropdown">
              {suppliers.map((sup) => (
                <div key={sup.supplierCd} className="patient-item" onClick={() => selectSupplier(sup)}>
                  {sup.supplierCd} | {sup.supplierName}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      <form className="luxury-form">
        
        {/* IDENTIFICATION ROW */}
        <div className="form-grid" style={{ marginBottom: '20px' }}>
           <div className="input-box read-only">
            <label style={{ fontSize: '12px', fontWeight: 'bold' }}>Supplier ID</label>
            <input type="text" name="supplierCd" value={formData.supplierCd} readOnly style={{ width: '150px' }} />
          </div>
        </div>

        {/* DETAILS GRID */}
        <div className="form-grid">
          <div className="input-box">
            <label>Supplier Name</label>
            <input type="text" name="supplierName" value={formData.supplierName} onChange={handleChange} disabled={isDisabled} />
          </div>
          <div className="input-box">
            <label>Supplier Address</label>
            <input type="text" name="supplierAddress" value={formData.supplierAddress} onChange={handleChange} disabled={isDisabled} />
          </div>

          <div className="input-box">
            <label>Contact Person</label>
            <input type="text" name="contactPerson" value={formData.contactPerson} onChange={handleChange} disabled={isDisabled} />
          </div>
          <div className="input-box">
            <label>Contact Person Phone</label>
            <input type="text" name="contactPersonPhone" value={formData.contactPersonPhone} onChange={handleChange} disabled={isDisabled} />
          </div>
          
          <div className="input-box">
            <label>Contact Person Email</label>
            <input type="email" name="contactPersonEmail" value={formData.contactPersonEmail} onChange={handleChange} disabled={isDisabled} />
          </div>
          <div className="input-box">
            <label>Credit Days</label>
            <input type="number" name="creditDays" value={formData.creditDays} onChange={handleChange} disabled={isDisabled} />
          </div>
          
          <div className="input-box">
            <label>TIN</label>
            <input type="text" name="tin" value={formData.tin} onChange={handleChange} disabled={isDisabled} />
          </div>
          <div className="input-box">
            <label>PAN</label>
            <input type="text" name="pan" value={formData.pan} onChange={handleChange} disabled={isDisabled} />
          </div>

          <div className="input-box">
            <label>TDS Section</label>
            <input type="text" name="tdsSection" value={formData.tdsSection} onChange={handleChange} disabled={isDisabled} />
          </div>
          <div className="input-box">
            <label>Bank Account Number</label>
            <input type="text" name="bankAccountNumber" value={formData.bankAccountNumber} onChange={handleChange} disabled={isDisabled} />
          </div>
          
          <div className="input-box">
            <label>Bank Branch</label>
            <input type="text" name="bankBranch" value={formData.bankBranch} onChange={handleChange} disabled={isDisabled} />
          </div>
          <div className="input-box">
            <label>IFSC</label>
            <input type="text" name="ifsc" value={formData.ifsc} onChange={handleChange} disabled={isDisabled} />
          </div>
          
          <div className="input-box">
            <label>GST Registration</label>
            <select name="gstRegistration" value={formData.gstRegistration} onChange={handleChange} disabled={isDisabled}>
              <option value="Y">Y</option>
              <option value="N">N</option>
            </select>
          </div>
          
          {/* GST NUMBER WITH INLINE BUTTON BELOW IT */}
          <div className="input-box">
            <label>GST No</label>
            <input type="text" name="gstNo" value={formData.gstNo} onChange={handleChange} disabled={isDisabled} />
            
            {formData.gstRegistration === "Y" && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '8px' }}>
                <button 
                  type="button" 
                  onClick={verifyGST} 
                  disabled={isDisabled || !formData.gstNo || isVerifyingGST}
                  style={{ 
                    padding: '4px 12px', 
                    backgroundColor: '#007bff', 
                    color: 'white', 
                    border: 'none', 
                    borderRadius: '4px', 
                    cursor: 'pointer',
                    fontSize: '12px'
                  }}
                >
                  {isVerifyingGST ? "Verifying..." : "Verify GST"}
                </button>
                {gstStatus === "failed" && <span style={{ color: 'red', fontSize: '12px', fontWeight: 'bold' }}>GST Verification Failed</span>}
                {gstStatus === "verified" && <span style={{ color: 'green', fontSize: '12px', fontWeight: 'bold' }}>Verified</span>}
              </div>
            )}
          </div>
        </div>

        {/* DYNAMIC ITEMS TABLE */}
        <div className="dynamic-table-wrapper" style={{ marginTop: '20px', overflowX: 'auto', border: '1px solid #ccc', borderRadius: '4px' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', minWidth: '600px' }}>
            <thead style={{ backgroundColor: '#e9ecef', borderBottom: '2px solid #ccc' }}>
              <tr>
                <th style={{ padding: '10px', borderRight: '1px solid #ccc', width: '60px' }}>Sl No.</th>
                <th style={{ padding: '10px', borderRight: '1px solid #ccc', width: '30%' }}>Item Code 1</th>
                <th style={{ padding: '10px' }}>Item Description</th>
                <th style={{ padding: '10px', width: '50px', textAlign: 'center' }}>X</th>
              </tr>
            </thead>
            <tbody>
              {tableRows.map((row, index) => (
                <tr key={row.id} style={{ borderBottom: '1px solid #ddd', backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                  <td style={{ padding: '10px', borderRight: '1px solid #ccc', textAlign: 'center' }}>{index + 1}</td>
                  <td style={{ padding: '10px', borderRight: '1px solid #ccc' }}>
                    <select 
                      value={row.itemCd} 
                      onChange={(e) => handleItemSelect(index, e.target.value)}
                      disabled={isDisabled}
                      style={{ width: '100%', padding: '6px', border: '1px solid #ccc', borderRadius: '4px' }}
                    >
                      <option value="">Select Item</option>
                      {itemsMasterList.map(item => (
                        <option key={item.itemCd} value={item.itemCd}>
                          {item.itemCd} - {item.itemDesc}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td style={{ padding: '10px' }}>{row.itemDesc}</td>
                  <td style={{ padding: '10px', textAlign: 'center' }}>
                    {!isDisabled && tableRows.length > 1 && (
                       <button type="button" onClick={() => removeRow(index)} style={{ color: 'red', fontWeight: 'bold', cursor: 'pointer', border: 'none', background: 'none' }}>X</button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {!isDisabled && (
            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px', backgroundColor: '#e9ecef' }}>
              <button 
                type="button" 
                onClick={addRow}
                style={{ padding: '6px 12px', cursor: 'pointer', backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px', fontWeight: 'bold' }}
              >
                + Add Row
              </button>
            </div>
          )}
        </div>

      </form>
    </div>
  );
};

export default SupplierMaster;